export default {"src":"https://static.spiritory.com/_next/static/media/letter.33d6bc02.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};